module.exports = __webpack_public_path__ + "img/scene5-9.d10d820b.jpg";